import { FunctionComponent, useState } from 'react';
import Slider from 'react-slick';
import FursysBenefit1Wrapper from './fursysBenefit1.style';
import { getStaticImageUrl } from '@utils/createImageUrl';
import ArrowRightIcon from '../../public/icon/ArrowRight';
import ArrowLeftIcon from '../../public/icon/ArrowLeft';
import { sendAmplitudeEvent } from '../../utils/amplitude';

const FursysBenefit1: FunctionComponent = () => {
  const FursysMain = [
    {
      mobileImage: getStaticImageUrl({ fileName: 'mobile-desker-banner.png' }),
      desktopImage: getStaticImageUrl({ fileName: 'desktop-desker-banner.png' }),
      link: 'https://www.desker.co.kr/',
      label: 'desker-home',
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'mobile-fursys-banner.png' }),
      desktopImage: getStaticImageUrl({ fileName: 'desktop-fursys-banner.png' }),
      link: 'https://www.fursys.com/fur_frt/common/main.do',
      label: 'fursys-home',
    },
    {
      mobileImage: getStaticImageUrl({ fileName: 'mobile-sidiz-banner.png' }),
      desktopImage: getStaticImageUrl({ fileName: 'desktop-sidiz-banner.png' }),
      link: 'https://www.sidiz.com/',
      label: 'sidiz-home',
    },
  ];
  const [currentSlide, setCurrentSlide] = useState(0);
  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide > 0) {
      return (
        <div
          className={className}
          style={{
            ...style,
            left: 'calc(50% - 604px)',
            top: 'calc(50% - 17px)',
            zIndex: '2',
          }}
          onClick={onClick}
        >
          <ArrowLeftIcon />
        </div>
      );
    } else {
      return <></>;
    }
  }
  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    if (currentSlide < FursysMain.length - 1) {
      return (
        <div
          className={className}
          style={{
            ...style,
            left: 'calc(50% + 576px)',
            top: 'calc(50% - 17px)',
            zIndex: '5',
          }}
          onClick={onClick}
        >
          <ArrowRightIcon />
        </div>
      );
    } else {
      return <></>;
    }
  }

  const settings = {
    className: 'slider variable-width',
    centerMode: false,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (_: number, next: number) => {
      setCurrentSlide(next);
    },
  };

  const mobileSettings = {
    centerMode: false,
    autoplay: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    dots: true,
    dragAble: true,
    arrows: false,
  };

  return (
    <FursysBenefit1Wrapper>
      <p className="benfit">혜택</p>
      <p className="slidTitle">
        고급 브랜드 가구를
        <br />
        특별가에&nbsp;
        <br className="mobile" />
        구매하실 수 있습니다.
      </p>
      <p className="slideDescription">
        퍼시스, 데스커, 시디즈 세 브랜드의 제품을<span className="desktop">&nbsp;</span>
        <br className="mobile" />
        특별가로 구매 가능하며<span className="mobile">&nbsp;</span>
        <br className="desktop" />
        변호사님의 사무실에 맞춰<span className="desktop">&nbsp;</span>
        <br className="mobile" />
        합리적이고 매력적인 가격, 면적, 컨셉의 공간을<span className="desktop">&nbsp;</span>
        <br className="mobile" />
        무료로 제안해드립니다.
      </p>

      <a
        className="downloadButton"
        href="/pdf/fursys_info.pdf"
        target="_blank"
        onClick={() => sendAmplitudeEvent('sqr_click_fursys', { label: 'fursys_info' })}
      >
        공간제안서 보기
      </a>

      <div className="fursysbrand--list desktop">
        <Slider {...settings}>
          {FursysMain.map((process, index) => (
            <div className="fursysbrand--item" key={index}>
              <a
                href={process.link}
                target="_blank"
                onClick={() => sendAmplitudeEvent('sqr_click_fursys', { label: process.label })}
              >
                <img className="solutionprocess--item-image" src={process.desktopImage} />
              </a>
            </div>
          ))}
        </Slider>
      </div>

      <div className="fursysbrand--list-mobile mobile">
        <Slider {...mobileSettings}>
          {FursysMain.map((process, index) => (
            <div className="item" key={index}>
              <a href={process.link} target="_blank">
                <img className="solutionprocess--item-image" src={process.mobileImage} />
              </a>
            </div>
          ))}
        </Slider>
      </div>
    </FursysBenefit1Wrapper>
  );
};

export default FursysBenefit1;
